export default "__VITE_ASSET__88801f87__"